<template>
  <el-dialog
    :visible.sync="visible"
    title="简历政策"
    v-if="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="40%"
  >
    <div>
      <div>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt">欢迎来到简历</span
          ><span style="font-size: 11pt">管理</span
          ><span style="font-size: 11pt">功能！当您使用</span
          ><span style="font-size: 11pt">本“服务”</span
          ><span style="font-size: 11pt">时，</span
          ><span style="font-size: 11pt">《简历政策》和</span
          ><span style="font-size: 11pt">您在注册</span
          ><span style="font-size: 11pt">BMW</span
          ><span style="font-size: 11pt"
            >经销商人才发展系统平台——全新悦学苑</span
          ><span style="font-size: 11pt">（下称“悦学苑”）</span
          ><span style="font-size: 11pt">账户时所确认的</span
          ><span style="font-size: 11pt">《隐私政策》</span
          ><span style="font-size: 11pt">同时</span
          ><span style="font-size: 11pt">适用。</span>
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt">华</span
          ><span style="font-size: 11pt">晨宝马汽车有限公司（</span
          ><span style="font-size: 11pt">下称</span
          ><span style="font-size: 11pt"
            >“我们”）深知个人信息对每一位用户的重要性，我们一向庄严承诺保护使用</span
          ><span style="font-size: 11pt">悦学苑</span
          ><span style="font-size: 11pt">之用户</span
          ><span style="font-size: 11pt">（</span
          ><span style="font-size: 11pt">下称</span
          ><span style="font-size: 11pt">“用户”或“您</span
          ><span style="font-size: 11pt">”</span
          ><span style="font-size: 11pt">）的个人信息及隐私安全。</span
          ><span style="font-size: 11pt">您</span
          ><span style="font-size: 11pt"
            >在使用悦学苑时，我们可能会收集和使用</span
          ><span style="font-size: 11pt">您</span
          ><span style="font-size: 11pt">的相关个人信息（</span
          ><span style="font-size: 11pt">下称</span
          ><span style="font-size: 11pt">“个人信息”）。</span>
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt">本《</span
          ><span style="font-size: 11pt">简历</span
          ><span style="font-size: 11pt">政策》将帮助您了解以下内容：</span>
        </p>
        <p
          style="
            background-color: #ffffff;
            margin: 0pt 0pt 5pt 18pt;
            text-indent: -18pt;
          "
        >
          <span style="font-size: 11pt">一、</span
          ><span style="font-size: 7pt; font-family: 'Times New Roman', sans-serif"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <span style="font-size: 11pt">我们收集的信息</span>
        </p>
        <p
          style="
            background-color: #ffffff;
            margin: 0pt 0pt 5pt 18pt;
            text-indent: -18pt;
          "
        >
          <span style="font-size: 11pt">二、</span
          ><span style="font-size: 7pt; font-family: 'Times New Roman', sans-serif"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 11pt">简历信息的使用</span>
        </p>
        <p
          style="
            background-color: #ffffff;
            margin: 0pt 0pt 5pt 18pt;
            text-indent: -18pt;
          "
        >
          <span style="font-size: 11pt">三、</span
          ><span style="font-size: 7pt; font-family: 'Times New Roman', sans-serif"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 11pt">为您提供安全保障</span>
        </p>
        <p
          style="
            background-color: #ffffff;
            margin: 0pt 0pt 5pt 18pt;
            text-indent: -18pt;
          "
        >
          <span style="font-size: 11pt">四、</span
          ><span style="font-size: 7pt; font-family: 'Times New Roman', sans-serif"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><span style="font-size: 11pt">免责声明和有限责任</span>
        </p>
        <p
          style="
            background-color: #ffffff;
            margin: 0pt 0pt 5pt 18pt;
            text-indent: -18pt;
          "
        >
          <span style="font-size: 11pt">五、</span
          ><span style="font-size: 7pt; font-family: 'Times New Roman', sans-serif"
            >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span
          ><span style="-aw-comment-end: _cmntref1"></span
          ><span style="font-size: 11pt">其他重要信息</span>
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 30pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt; font-weight: bold">一、</span
          ><span style="font-size: 11pt; font-weight: bold">我们</span
          ><span style="font-size: 11pt; font-weight: bold">收集的信息</span>
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt">我们收集您的</span
          ><span style="font-size: 11pt">简历相关</span
          ><span style="font-size: 11pt">信息主要</span
          ><span style="font-size: 11pt"
            >是通过您的个人输入和定期维护更新。其中您的姓名、证件编号、手机号码及邮箱等个人基本信息均来自</span
          ><span style="font-size: 11pt"
            >悦学苑的账号注册，《隐私政策》适用。在本《简历政策》范围内，您将可以</span
          ><span style="font-size: 11pt">自行选择提供您的</span
          ><span style="font-size: 11pt">微信号</span
          ><span style="font-size: 11pt"
            >，国籍、籍贯、所在城市、参加工作时间等个人信息，并</span
          ><span style="font-size: 11pt">维护自己的</span
          ><span style="font-size: 11pt"
            >教育经历、工作经历、个人技能等信息，建立自己的个人档案。</span
          >
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 30pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt; font-weight: bold">二</span
          ><span style="font-size: 11pt; font-weight: bold">、</span
          ><span style="font-size: 11pt; font-weight: bold"
            >简历信息的使用</span
          >
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt">1、</span
          ><span style="font-size: 11pt"
            >基于您的个人情况及工作经历为您建议更适宜的悦学苑学习路径，助力您在BMW网络内的个人成长。</span
          >
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt"
            >2、为指定岗位（例如：经销商关键管理岗）提供定制的第三方能力评估等服务，并有针对性的提供进阶学习建议。</span
          >
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt">3</span
          ><span style="font-size: 11pt">、</span
          ><span style="font-size: 11pt"
            >若您选择离开当前工作的组织，您可以自由选择是否加入</span
          ><span style="font-size: 11pt">BMW</span
          ><span style="font-size: 11pt">网络人才库。若您加入</span
          ><span style="font-size: 11pt">BMW</span
          ><span style="font-size: 11pt">网络人才库，您的简历将在</span
          ><span style="font-size: 11pt">BMW</span
          ><span style="font-size: 11pt"
            >经销商网络中公开，并可获得更多网内就职机会</span
          ><span style="font-size: 11pt">。</span
          ><span style="font-size: 11pt"
            >您也可以随时选择退出人才库，取消简历的分享。</span
          >
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt">若</span
          ><span style="font-size: 11pt">您不再</span
          ><span style="font-size: 11pt">希望您的简历在</span
          ><span style="font-size: 11pt"
            >悦学苑中保存，您可以选择取消“同意《简历政策》”，您的简历信息将从悦学苑中彻底删除（《隐私协议》范围内的个人基本信息除外）。</span
          >
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 30pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt; font-weight: bold">三、</span
          ><span style="font-size: 11pt; font-weight: bold"
            >为您提供安全保障</span
          >
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt; font-weight: bold"
            >您了解并同意，在收集您的</span
          ><span style="font-size: 11pt; font-weight: bold">简历</span
          ><span style="font-size: 11pt; font-weight: bold"
            >信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理</span
          ><span style="font-size: 11pt; font-weight: bold">后</span
          ><span style="font-size: 11pt; font-weight: bold">的</span
          ><span style="font-size: 11pt; font-weight: bold">简历数据</span
          ><span style="font-size: 11pt; font-weight: bold"
            >将无法识别您的身份，在此情况下我们有权使用已经去标识化的个人信息，对用户数据库进行分析并予以商业化的利用。</span
          >
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 30pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt; font-weight: bold">四</span
          ><span style="font-size: 11pt; font-weight: bold"
            >、免责声明和有限责任</span
          >
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 16.5pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt"
            >我们的多项服务可让您与使用该服务的所有用户公开分享您的相关简历信息，</span
          ><span style="font-size: 11pt"
            >只要您不删除您所公开或共享的简历信息，有关个人信息可能一直留存在公众领域；即使您删除共享的简历信息，有关个人信息仍可能由其他用户或不受我们控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。</span
          ><span style="font-size: 11pt; font-weight: bold"
            >如您同意将个人简历信息公开或共享，由此造成您的个人信息泄露，我们不承担责任。因此，我们提醒并请您慎重考虑公开或共享您的简历信息。</span
          >
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 30pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt; font-weight: bold">五</span
          ><span style="font-size: 11pt; font-weight: bold"
            >、其他重要信息</span
          >
        </p>
        <p style="background-color: #ffffff; margin: 0pt 0pt 5pt">
          <span style="font-size: 11pt; font-weight: bold"
            >请您注意，如果我们要将您的简历</span
          ><span style="font-size: 11pt; font-weight: bold">信息用于本</span
          ><span style="font-size: 11pt; font-weight: bold">《简历</span
          ><span style="font-size: 11pt; font-weight: bold"
            >政策》中未载明的其他用途或额外收集未提及的其他个人信息，我们会另行事先请您同意（确认同意的方式：如勾选、弹窗、站内信、邮件、短信等方式）。一旦您同意，该等额外用途将视为本《隐私政策》的一部分，该等额外个人信息也将适用本《隐私政策》。</span
          >
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 30pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt; font-weight: bold">六</span
          ><span style="font-size: 11pt; font-weight: bold">、通知和修订</span>
        </p>
        <p
          style="
            background-color: #ffffff;
            line-height: 16.5pt;
            margin: 11.25pt 0pt 5pt;
          "
        >
          <span style="font-size: 11pt">我们可能适时修改本《</span
          ><span style="font-size: 11pt">简历</span
          ><span style="font-size: 11pt">政策》的条款，该等修改构成本《</span
          ><span style="font-size: 11pt">简历</span
          ><span style="font-size: 11pt"
            >政策》的一部分。对于重大变更，我们会提供更显著的通知，您如果不同意该等变更，可以选择停止使用</span
          ><span style="font-size: 11pt">悦学苑APP</span
          ><span style="font-size: 11pt"
            >；如您仍然继续使用，即表示同意受经修订的本《隐私政策》的约束。</span
          >
        </p>
      </div>
    </div>

    <template slot="footer">
      <div v-show="disabled">
        <el-button type="" @click="sendEnabled(true)" class="buttonqxy"
          >关闭
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import $ from "jquery";

export default {
  data() {
    return {
      visible: false,
      disabled: true,
    };
  },
  methods: {
    init() {
      this.visible = true;
      //this.$nextTick(() => {
      //   this.getConfirm(10)
      //})
    },
    getConfirm(time) {
      var _this = this;
      if (time === 0) {
        this.disabled = false;
        $(".buttonqx").html("不同意");
        $(".buttonqy").html("同意");
      } else {
        // 按钮不可用
        this.disabled = true;
        $(".buttonqxy").html(this.$t("agreement.confirm", { handle: time }));
        // $('.buttonqy').html(this.$t('agreement.confirm', { 'handle': time }))
        time--;
        setTimeout(function () {
          _this.getConfirm(time);
        }, 1000);
      }
    },
    sendEnabled(val) {
      this.$emit("func", val);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.disableClick {
  text-align: center;
}

.el-input-number {
  width: 100% !important;
}

.el-input__inner {
  text-align: left !important;
}

.el-button.el-button--default.buttonqx {
  margin: 0px !important;
  width: 50%;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background-color: #434343 !important;
  color: #fff;
  border: 0px;
  line-height: 25px;
}

.el-button.el-button--default.buttonqy {
  margin: 0px !important;
  width: 50%;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  color: #fff;
  border: 0px;
  line-height: 25px;
}

.el-button.el-button--default.buttonqxy {
  margin: 0px !important;
  width: 100%;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background-color: #999999 !important;
  color: #fff;
  border: 0px;
  line-height: 25px;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #666;
  background-color: #eee;
}

.el-button.el-button--default.is-disabled:hover {
  color: #666;
  background-color: #eee !important;
}

.el-button.el-button--default.is-disabled {
  color: #666;
  background-color: #eee !important;
}

.el-button.el-button--default {
  color: #fff;
  background-color: #5c9df5 !important;
  border-color: #5c9df5;
}

.buttomqr {
  margin-left: 0px !important;
  float: left !important;
  width: 100% !important;
  line-height: 23px;
}

.el-dialog__body div {
  // margin-top: 16px;
  line-height: 20px;
}

.el-dialog__header {
  text-align: center;
  font-size: 18px;
}
</style>
